import { type ReactNode } from "react";

/** External project link card (Other projects). */
export function ProjectCard({
  name,
  url,
  href,
  children,
}: {
  name: string;
  url: string;
  href: string;
  children: ReactNode;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener"
      className="panel panel-hover group relative block p-6 no-underline hover:no-underline"
    >
      <span className="absolute right-5 top-5 text-text-mute transition-colors group-hover:text-amber">
        ↗
      </span>
      <div className="font-display text-[17px] font-semibold tracking-wide text-text">{name}</div>
      <div className="font-mono text-[11px] text-amber">{url}</div>
      <p className="mt-2 text-[15px] text-text-dim">{children}</p>
    </a>
  );
}
